import { Button, Card, Flex, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { CompanyModel } from '../../../types/admin';
import { countSuccessfulGenerationsByCompanyId } from '../../../api/countSuccessfulGenerationsByCompanyId';

interface CompanyOverviewTabProps {
    company: CompanyModel;
    open: boolean;
    onDeleteClick: () => void;
}

const CompanyOverviewTab: React.FC<CompanyOverviewTabProps> = ({
    company,
    open,
    onDeleteClick,
}) => {
    const [loading, setLoading] = useState(false);
    const [successfulGenerationsCount, setSuccessfulGenerationsCount] = useState(0);

    useEffect(() => {
        if (!open) return;
        let mounted = true;
        const fetchSuccessfulGenerationsCount = async () => {
            try {
                setLoading(true);
                const data = await countSuccessfulGenerationsByCompanyId(company.id);
                if (mounted) {
                    setSuccessfulGenerationsCount(data.count);
                }
            } catch (error) {
                console.error('Error fetching successful generations count:', error);
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        };
        fetchSuccessfulGenerationsCount();
        return () => {
            mounted = false;
        };
    }, [company.id, open]);

    return (
        <Card
            title={
                <Flex justify="space-between" align="center">
                    <div>
                        <div>{company.name}</div>
                        <div style={{ fontSize: 12, color: '#999' }}>
                            {loading
                                ? 'Loading generations...'
                                : `Successful generations: ${successfulGenerationsCount}`}
                        </div>
                    </div>
                    <Button
                        variant="solid"
                        color="danger"
                        onClick={onDeleteClick}
                        disabled
                    >
                        Delete
                    </Button>
                </Flex>
            }
        >
            <Space direction="vertical">
                <div>Status: {company.status || 'created'}</div>
                <div>
                    Modules:{' '}
                    {company.modules
                        ? Object.entries(company.modules)
                              .filter(([, enabled]) => enabled)
                              .map(([key]) => key)
                              .join(', ') || '-'
                        : '-'}
                </div>
            </Space>
        </Card>
    );
};

export default CompanyOverviewTab;
